import { Container, Section, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import React, { useState } from 'react';
import { HomeHeader } from 'src/components/selfService/features/Home/HomeHeader/HomeHeader';
import { Contact } from 'src/components/selfService/features/Home/Contact/Contact';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { BalanceProvider } from 'src/components/selfService/common/Balance/context/BalanceProvider';
import { BalanceStatusSection } from 'src/components/selfService/common/Balance/sections/BalanceStatusSection/BalanceStatusSection';
import { useBalanceAccountInfo } from 'src/components/selfService/common/Balance/hooks/useBalanceAccountInfo';
import { BalanceCreditProgressSection } from 'src/components/selfService/common/Balance/sections/BalanceCreditProgressSection/BalanceCreditProgressSection';
import { NetTermsPromotionSection } from 'src/components/selfService/common/Balance/sections/NetTermsPromotionSection/NetTermsPromotionSection';
import { CongratulatoryModal } from 'src/components/CongratulatoryModal/CongratulatoryModal';
import { useGetQueryParams } from 'src/utilities/useGetQueryParams';
import { IllustrationContainer } from './IllustrationContainer/IllustrationContainer';

export default function HomeLandingPage(): JSX.Element {
  const { isPhone } = useScreenSizes();

  const { isBalanceAccount } = useBalanceAccountInfo();
  const firstTime = useGetQueryParams('firstTime');

  const isFirstTimeVisit = Boolean(firstTime);

  const [isCongratulatoryModalVisible, setIsCongratulatoryModalVisible] =
    useState(isFirstTimeVisit && isBalanceAccount);

  return (
    <BalanceProvider>
      <Stack overflow="hidden">
        <Container variant="default">
          <Section inset="md">
            {isBalanceAccount && <BalanceStatusSection />}
            <HomeHeader />
            {isBalanceAccount && <NetTermsPromotionSection />}
            {isBalanceAccount && <BalanceCreditProgressSection />}
            <Stack y="md">
              <IllustrationContainer />
            </Stack>
            <Stack y={isPhone ? 'x-lg' : 'none'}>
              <Contact />
            </Stack>
          </Section>
        </Container>
      </Stack>
      {isCongratulatoryModalVisible && (
        <CongratulatoryModal
          onClose={() => setIsCongratulatoryModalVisible(false)}
        />
      )}
    </BalanceProvider>
  );
}
